import remarkParse from 'remark-parse';
import remarkRehype from 'remark-rehype';
import { unified } from 'unified';
export const nonNullable = (value) => value != null;
const transform = (node) => {
    if (node.type !== 'element' ||
        node.properties === undefined ||
        !Array.isArray(node.properties.className))
        return;
    node.properties.class = node.properties.className.join(' ');
    delete node.properties.className;
};
const visit = (visitor, node) => {
    visitor(node);
    if (node.type === 'comemnt' ||
        node.type === 'doctype' ||
        node.type === 'text')
        return;
    node.children?.forEach((child) => visit(visitor, child));
};
const rehypeReactClassNameToSvelteClass = () => {
    return (node, _file, done) => {
        try {
            visit(transform, node);
            done();
        }
        catch (e) {
            if (e instanceof Error)
                return done(e);
            return done(new Error(String(e)));
        }
    };
};
export const createParser = (plugins) => {
    const processor = unified()
        .use(remarkParse)
        .use(plugins.map((plugin) => plugin.remarkPlugin).filter(nonNullable))
        .use(remarkRehype, { allowDangerousHtml: true })
        .use(plugins.map((plugin) => plugin.rehypePlugin).filter(nonNullable))
        .use(rehypeReactClassNameToSvelteClass);
    return (md) => processor.runSync(processor.parse(md), md);
};
